import { Link } from "react-router-dom";
import { siteConfig, categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
            <div>
              <Link to="/" className="text-2xl font-bold font-heading cursor-pointer">
                韩漫屋
              </Link>
              <p className="mt-4 text-sm text-accent-200/70 leading-relaxed">
                {siteConfig.description.slice(0, 80)}...
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a
                  href={siteConfig.social.updates}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-800/50 hover:bg-accent-700 transition-colors cursor-pointer"
                  aria-label="站内动态"
                >
                  <i className="ri-notification-3-line text-sm" />
                </a>
                <a
                  href={siteConfig.social.popular}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-800/50 hover:bg-accent-700 transition-colors cursor-pointer"
                  aria-label="热门内容"
                >
                  <i className="ri-fire-line text-sm" />
                </a>
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-800/50 hover:bg-accent-700 transition-colors cursor-pointer"
                  aria-label="邮箱"
                >
                  <i className="ri-mail-line text-sm" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-accent-300 mb-5">
                热门分类
              </h4>
              <ul className="flex flex-col gap-3">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-accent-100/70 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-accent-300 mb-5">
                快速链接
              </h4>
              <ul className="flex flex-col gap-3">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-accent-100/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-accent-100/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/romance"
                    className="text-sm text-accent-100/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    恋爱甜漫
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/action"
                    className="text-sm text-accent-100/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    热血动作
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/fantasy"
                    className="text-sm text-accent-100/70 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    奇幻冒险
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-accent-300 mb-5">
                联系我们
              </h4>
              <p className="text-sm text-accent-100/70 leading-relaxed mb-4">
                合作洽谈、内容反馈、广告投放等请通过以下方式联系我们
              </p>
              <div className="flex flex-col gap-2">
                <span className="text-sm text-accent-100/70">
                  <i className="ri-mail-line mr-2" />
                  {siteConfig.email}
                </span>
                <span className="text-sm text-accent-100/70">
                  <i className="ri-wechat-line mr-2" />
                  微信：{siteConfig.social.wechat}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-accent-800/50">
        <div className="w-full px-4 md:px-6 py-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-7xl md:text-9xl font-black font-heading text-accent-800/20 leading-none select-none">
              韩漫屋
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-accent-800/50">
        <div className="w-full px-4 md:px-6 py-6">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-accent-300/50">
              &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-accent-300/50 hover:text-accent-200 transition-colors cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-xs text-accent-300/50 hover:text-accent-200 transition-colors cursor-pointer">
                使用条款
              </a>
              <a href="#" className="text-xs text-accent-300/50 hover:text-accent-200 transition-colors cursor-pointer">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
